var exports = {
  "spinner": "Spinner.module__spinner___WXVzbU",
  "spinnerInner": "Spinner.module__spinnerInner___WXVzbU",
  "spinnerItem": "Spinner.module__spinnerItem___WXVzbU",
  "spinnerPulsingEllipsis": "Spinner.module__spinnerPulsingEllipsis___WXVzbU",
  "small": "Spinner.module__small___WXVzbU",
  "medium": "Spinner.module__medium___WXVzbU",
  "large": "Spinner.module__large___WXVzbU",
  "delay1": "Spinner.module__delay1___WXVzbU",
  "delay2": "Spinner.module__delay2___WXVzbU",
  "srOnly": "Spinner.module__srOnly___WXVzbU",
};

__webpack_require__.r(module.exports = exports);
